import React from 'react';
import PropTypes from 'prop-types';
import MuiPaper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  alignStart: {
    '& > *': {
      alignContent: 'flex-start',
    },
  },
});

const ListItem = React.forwardRef(({
  className, classes, expand, alternativeToggleDisplay, ...rest
}, ref) => {
  return (
    <MuiPaper
      test="action-item-list-item"
      elevation={0}
      className={classNames(classes.root, className, {
        [classes.alignStart]: expand,
        [classes.alternativeToggleOn]: alternativeToggleDisplay,
      })}
      variant="subtle"
      square
      ref={ref}
      {...rest}
    />
  );
});

ListItem.defaultProps = {
  className: '',
};

ListItem.propTypes = {
  expand: PropTypes.bool.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListItem);
